import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

function formatFieldPath(loc = []) {
  const path = loc
    .filter((segment) => !["body", "query", "path"].includes(String(segment)))
    .map((segment) => String(segment).replace(/_/g, " "))
    .join(" ");

  if (!path) return "";
  return path.charAt(0).toUpperCase() + path.slice(1);
}

export function getErrorMessage(error, fallback = "Something went wrong") {
  const detail = error?.response?.data?.detail;

  if (Array.isArray(detail)) {
    const messages = detail
      .map((item) => {
        if (typeof item === "string") return item;
        if (item && typeof item === "object") {
          const field = formatFieldPath(item.loc);
          const message = item.msg || item.message || "";
          return field ? `${field}: ${message}` : message;
        }
        return "";
      })
      .filter(Boolean);

    return messages.length > 0 ? messages.join(" ") : fallback;
  }

  if (typeof detail === "string" && detail.trim()) {
    return detail;
  }

  if (detail && typeof detail === "object") {
    if (typeof detail.message === "string" && detail.message.trim()) {
      return detail.message;
    }
  }

  if (typeof error?.message === "string" && error.message.trim()) {
    return error.message;
  }

  return fallback;
}
